export default __webpack_public_path__ + "static/media/login-bg@2x.71ec17b1.png";